module.exports = __webpack_public_path__ + "img/image4.28c1dacf.png";